"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgEyeOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M11.947 6h.058c3.003-.002 6.163 1.52 9.36 4.548 0 0 .63.522.63 1.452 0 .93-.608 1.43-.608 1.43-3.178 3.017-6.324 4.535-9.303 4.57h-.089c-3.004.005-6.142-1.517-9.344-4.551 0 0-.651-.52-.651-1.45 0-.93.654-1.451.654-1.451C5.838 7.532 8.956 6.02 11.947 6zM6.342 9.998c-.836.6-1.62 1.27-2.342 2.002.78.78 1.561 1.448 2.342 2A5.99 5.99 0 016 12c0-.702.12-1.376.342-2.002zm11.318.006c.22.625.34 1.296.34 1.996 0 .699-.12 1.37-.34 1.994A18.2 18.2 0 0019.996 12a18.156 18.156 0 00-2.335-1.996h-.001zM12 16a4 4 0 100-8 4 4 0 000 8zm-.005-2a2.001 2.001 0 11.002-4.002A2.001 2.001 0 0111.995 14z' }))); };
exports.default = SvgEyeOutline;
//# sourceMappingURL=EyeOutline.js.map